import styled from "styled-components";
import { colorTheme, textTheme } from "../../theme";

type StrengthFinderState = {
  isExpanded?: boolean;
};

export const Container = styled.div<StrengthFinderState>`
  display: flex;
  align-items: center;
  width: 490px;
  height: ${props => (props.isExpanded ? "76px" : "43px")};
  border: 1px solid ${colorTheme.grayLightest};
  box-sizing: border-box;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  padding: 5px 6px;
  margin-bottom: 10px;
`;

export const ColorBar = styled.div`
  background-color: ${props => (props.color ? props.color : "")};
  width: 6px;
  height: 100%;
  border-radius: 2px 0px 0px 2px;
  margin-right: 15px;
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.div`
  ${textTheme.subtitle1};
  margin-right: 73px;
`;

export const Description = styled.div<StrengthFinderState>`
  ${colorTheme.grayDark};
  width: ${props => (props.isExpanded ? "332px" : "250px")};
  font-family: "Open Sans";
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 15px;
  overflow: ${props => (props.isExpanded ? "" : "hidden")};
  white-space: ${props => (props.isExpanded ? "" : "nowrap")};
`;

export const Toggle = styled.span`
  color: ${colorTheme.newBlue};
  font-family: "Open Sans";
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 15px;
  &:hover {
    cursor: pointer;
  }
  margin-left: 5px;
`;
